export const QUICK_REPLY_CATEGORIES = [
  {
    id: "cocacola",
    label: "🔴 Portafolio Coca-Cola",
    description: "Productos, surtido y oportunidades comerciales",
    questions: [
      {
        id: "cocacola_1",
        label: "Qué productos tener",
        userMessage:
          "¿Qué productos Coca-Cola debería tener en mi almacén para vender más?",
      },
      {
        id: "cocacola_2",
        label: "Mejorar exhibición",
        userMessage:
          "¿Cómo puedo exhibir mejor los productos Coca-Cola en mi negocio?",
      },
      {
        id: "cocacola_3",
        label: "Promociones Coca-Cola",
        userMessage:
          "Dame ideas de promociones usando productos Coca-Cola para aumentar mis ventas.",
      },
    ],
  },

  {
  id: "sustentabilidad",
  label: "♻️ Sustentabilidad y Reciclaje",
  description: "Reciclaje, reducción de residuos y buenas prácticas",
  questions: [
    {
      id: "sustentabilidad_1",
      label: "Reciclar en mi negocio",
      userMessage:
        "¿Cómo puedo implementar prácticas de reciclaje en mi almacén?",
    },
    {
      id: "sustentabilidad_2",
      label: "Reducir residuos",
      userMessage:
        "¿Qué acciones simples puedo realizar para reducir los residuos de mi negocio?",
    },
    {
      id: "sustentabilidad_3",
      label: "Nuestras iniciativas",
      userMessage:
        "¿Cuáles son las principales iniciativas de sustentabilidad y desarrollo comunitario impulsadas por Coca-Cola?",
    },
  ],
},

  {
    id: "inventario",
    label: "📦 Manejo de Inventario",
    description: "Stock, reposición y control de productos",
    questions: [
      {
        id: "inventario_1",
        label: "¿Cómo evito quedarme sin stock?",
        userMessage:
          "¿Qué puedo hacer para evitar quiebres de stock en mi almacén?",
      },
      {
        id: "inventario_2",
        label: "Productos que más rotan",
        userMessage:
          "¿Cómo puedo identificar los productos de mayor y menor rotación en mi almacén?",
      },
      {
        id: "inventario_3",
        label: "Cuándo volver a comprar",
        userMessage:
          "¿Cómo puedo planificar mejor las reposiciones de productos?",
      },
    ],
  },

  {
    id: "ventas",
    label: "📈 Aumento de Ventas",
    description: "Promociones, ticket promedio y crecimiento",
    questions: [
      {
        id: "ventas_1",
        label: "Ideas para vender más",
        userMessage:
          "Dame ideas simples y efectivas para aumentar las ventas de mi almacén.",
      },
      {
        id: "ventas_2",
        label: "Promociones que funcionan",
        userMessage:
          "¿Qué promociones puedo hacer para atraer más clientes y vender más?",
      },
      {
        id: "ventas_3",
        label: "Aumentar ticket promedio",
        userMessage:
          "¿Cómo puedo aumentar el ticket promedio de mis clientes?",
      },
    ],
  },

  {
    id: "digitalizacion",
    label: "📱 Digitalización del Negocio",
    description: "WhatsApp, pagos digitales y herramientas",
    questions: [
      {
        id: "digitalizacion_1",
        label: "Usar WhatsApp Business",
        userMessage:
          "¿Cómo puedo aprovechar WhatsApp Business para mi almacén?",
      },
      {
        id: "digitalizacion_2",
        label: "Pagos digitales",
        userMessage:
          "¿Qué opciones de pagos digitales debería implementar en mi negocio?",
      },
      {
        id: "digitalizacion_3",
        label: "Digitalizar mi almacén",
        userMessage:
          "¿Por dónde debería empezar para digitalizar mi almacén de barrio?",
      },
    ],
  },

  {
    id: "marketing",
    label: "📣 Marketing y Redes Sociales",
    description: "Redes sociales, promociones y clientes",
    questions: [
      {
        id: "marketing_1",
        label: "Qué publicar en redes",
        userMessage:
          "¿Qué contenido puedo publicar en redes sociales para atraer más clientes?",
      },
      {
        id: "marketing_2",
        label: "Promocionar por WhatsApp",
        userMessage:
          "¿Cómo puedo usar WhatsApp para promocionar mi almacén?",
      },
      {
        id: "marketing_3",
        label: "Conseguir nuevos clientes",
        userMessage:
          "¿Qué estrategias simples puedo usar para conseguir nuevos clientes?",
      },
    ],
  },

  {
    id: "finanzas",
    label: "💰 Finanzas para tu Negocio",
    description: "Ingresos, gastos, flujo de caja y rentabilidad",
    questions: [
      {
        id: "finanzas_1",
        label: "Controlar gastos",
        userMessage:
          "¿Cómo puedo controlar mejor los gastos de mi almacén y evitar pérdidas?",
      },
      {
        id: "finanzas_2",
        label: "Mejorar flujo de caja",
        userMessage:
          "¿Qué puedo hacer para mantener un flujo de caja saludable en mi negocio?",
      },
      {
        id: "finanzas_3",
        label: "Aumentar rentabilidad",
        userMessage:
          "¿Qué acciones puedo tomar para mejorar la rentabilidad de mi almacén?",
      },
    ],
  },
];

